import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';
import EventRegistrationEditForm from './EventRegistrationEditForm';

function EventRegistrationEditPage(props){
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [eventReg, setEventReg] = useState(null);
    const { eventId, regId } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/events/${eventId}/registrations/${regId}`).then(res => {
            setEventReg(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [eventId, regId]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A jelentkezés letöltése sikertelen." />;

    if (eventReg)
        return (
            <>
                <h1>Jelentkezés szerkesztése</h1>
                <EventRegistrationEditForm eventReg={eventReg} />
            </>
        );

    return null;
}

export default EventRegistrationEditPage;